import { generateId } from "@/utils/id";

const STORAGE_KEY = "macro-tracker:client-instance-id";

let cachedClientInstanceId: string | null = null;

export function getClientInstanceId(): string {
  if (cachedClientInstanceId) return cachedClientInstanceId;

  if (typeof window === "undefined") {
    cachedClientInstanceId = generateId();
    return cachedClientInstanceId;
  }

  try {
    const existing = window.sessionStorage.getItem(STORAGE_KEY);
    if (existing) {
      cachedClientInstanceId = existing;
      return cachedClientInstanceId;
    }

    cachedClientInstanceId = generateId();
    window.sessionStorage.setItem(STORAGE_KEY, cachedClientInstanceId);
    return cachedClientInstanceId;
  } catch {
    cachedClientInstanceId = generateId();
    return cachedClientInstanceId;
  }
}
